(function(){

    document.querySelectorAll('[data-adev-draggable-media="wrap"]:not(.adev-init)').forEach(root => {
        const itemEl = root.querySelectorAll('[data-adev-draggable-media="item"]');

        let e = 1;

        const start = (t) => {
            const r = t.target;
            e++;
            r.style.zIndex = e;
        }

        const move = (t) => {
            const e = t.target,
                    r = (parseFloat(e.getAttribute("data-x")) || 0) + t.dx,
                    a = (parseFloat(e.getAttribute("data-y")) || 0) + t.dy;
            e.style.transform = `translate(${r}px, ${a}px)`;
            e.setAttribute("data-x", r);
            e.setAttribute("data-y", a);
        }

        itemEl.forEach((t) => {
            interact(t).draggable({
                inertia: true,
                modifiers: [interact.modifiers.restrictRect({ restriction: "parent", endOnly: true })],
                autoScroll: true,
                listeners: {
                    start: start,
                    move: move
                }
            });
        });

        root.classList.add('adev-init');
    });


})();